<script setup lang="ts">
import { cn } from '../ui-utils.ts';
import {
  PopoverContent,
  type PopoverContentEmits,
  type PopoverContentProps,
  PopoverPortal,
  useForwardPropsEmits,
} from 'reka-ui';
import { type ComponentPublicInstance, computed, type HTMLAttributes, onMounted, ref, useTemplateRef } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<PopoverContentProps & { class?: HTMLAttributes['class']; disabled?: boolean }>(),
  {
    align: 'center',
    sideOffset: 4,
  },
);
const emits = defineEmits<PopoverContentEmits>();

const delegatedProps = computed(() => {
  const { class: _class, disabled: _disabled, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);

const popoverPortal = useTemplateRef<ComponentPublicInstance>('popoverPortal');
const style = ref('');

onMounted(() => {
  if (
    DEPLOYMENT_ORIGIN.includes('compliance') &&
    popoverPortal.value &&
    popoverPortal.value.$el.parentElement.closest('.modal')
  ) {
    style.value = 'z-index: 9052';
  }
});
</script>

<template>
  <PopoverPortal :disabled ref="popoverPortal">
    <PopoverContent
      v-bind="{ ...forwarded, ...$attrs }"
      :class="
        cn(
          'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border border-slate-200 bg-white p-4 text-slate-950 shadow-md outline-hidden',
          props.class,
        )
      "
      :style
    >
      <slot />
    </PopoverContent>
  </PopoverPortal>
</template>
